import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Reconocer el patrón sin culparme",
    opening: localizedGenderNode(
      [
      "Hoy no me juzgo. Reconozco un patrón — y me quedo conmigo."
    ],
      [
      "Hoy no me juzgo. Reconozco un patrón — y me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Es un patrón. No es un defecto en mí.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Es un patrón. No es un defecto en mí.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué tipo de personas me atraen una y otra vez, aunque me duela?\n[Escribe aquí]",
      "¿Qué tienen en común estas relaciones al mirarlas atrás?\n[Escribe aquí]",
      "¿Qué siento ahora al ver esto escrito?\n[Escribe aquí]"
    ],
      [
      "¿Qué tipo de personas me atraen una y otra vez, aunque me duela?\n[Escribe aquí]",
      "¿Qué tienen en común estas relaciones al mirarlas atrás?\n[Escribe aquí]",
      "¿Qué siento ahora al ver esto escrito?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un patrón nace de un dolor antiguo. Hoy solo lo veo."
    ],
      [
      "Cierre",
      "Un patrón nace de un dolor antiguo. Hoy solo lo veo."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase: “Estoy aprendiendo a entenderme, no a culparme.”",
      "Escribo una frase: “Estoy aprendiendo a entenderme, no a culparme.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El momento en que se siente “familiar”",
    opening: localizedGenderNode(
      [
      "Hoy identifico la sensación de “hogar” que me engaña."
    ],
      [
      "Hoy identifico la sensación de “hogar” que me engaña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo comienza normalmente la atracción intensa?\n[Escribe aquí]",
      "¿Cómo se manifiesta esa sensación de “familiaridad” en mi cuerpo?\n[Escribe aquí]",
      "¿Qué interpreto erróneamente como amor?\n[Escribe aquí]"
    ],
      [
      "¿Cuándo comienza normalmente la atracción intensa?\n[Escribe aquí]",
      "¿Cómo se manifiesta esa sensación de “familiaridad” en mi cuerpo?\n[Escribe aquí]",
      "¿Qué interpreto erróneamente como amor?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Familiar no siempre significa seguro."
    ],
      [
      "Cierre",
      "Familiar no siempre significa seguro."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparece un “clic” fuerte — una respiración + la pregunta: “¿Es familiar o es bueno para mí?”",
      "Cuando aparece un “clic” fuerte — una respiración + la pregunta: “¿Es familiar o es bueno para mí?”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que intento reparar a través de la relación",
    opening: localizedGenderNode(
      [
      "Hoy miro qué intento sanar a través de otros."
    ],
      [
      "Hoy miro qué intento sanar a través de otros."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué dolor antiguo se activa en estas relaciones?\n[Escribe aquí]",
      "¿Qué espero que finalmente ocurra “esta vez”?\n[Escribe aquí]",
      "¿Qué intento demostrar sobre mí?\n[Escribe aquí]"
    ],
      [
      "¿Qué dolor antiguo se activa en estas relaciones?\n[Escribe aquí]",
      "¿Qué espero que finalmente ocurra “esta vez”?\n[Escribe aquí]",
      "¿Qué intento demostrar sobre mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una relación no está para sanar una herida, sino para encontrarse desde la totalidad."
    ],
      [
      "Cierre",
      "Una relación no está para sanar una herida, sino para encontrarse desde la totalidad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo la frase: “No necesito demostrar mi valor a través del dolor.”",
      "Escribo la frase: “No necesito demostrar mi valor a través del dolor.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Intensidad vs. intimidad",
    opening: localizedGenderNode(
      [
      "Hoy separo el drama de la conexión."
    ],
      [
      "Hoy separo el drama de la conexión."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo se ve la “intensidad” en mis relaciones?\n[Escribe aquí]",
      "¿Dónde falta escucha, estabilidad, seguridad?\n[Escribe aquí]",
      "¿Cómo imagino una intimidad tranquila?\n[Escribe aquí]"
    ],
      [
      "¿Cómo se ve la “intensidad” en mis relaciones?\n[Escribe aquí]",
      "¿Dónde falta escucha, estabilidad, seguridad?\n[Escribe aquí]",
      "¿Cómo imagino una intimidad tranquila?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No toda emoción fuerte es amor."
    ],
      [
      "Cierre",
      "No toda emoción fuerte es amor."
    ]
    ),
    action: localizedGenderNode(
      "Hoy noto un momento de calma — y no huyo de él.",
      "Hoy noto un momento de calma — y no huyo de él."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Miedo a la estabilidad",
    opening: localizedGenderNode(
      [
      "Hoy reviso si la calma me asusta."
    ],
      [
      "Hoy reviso si la calma me asusta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me siento frente a una persona estable?\n[Escribe aquí]",
      "¿Qué me asusta de una relación tranquila?\n[Escribe aquí]",
      "¿Qué historia me cuento sobre la calma?\n[Escribe aquí]"
    ],
      [
      "¿Cómo me siento frente a una persona estable?\n[Escribe aquí]",
      "¿Qué me asusta de una relación tranquila?\n[Escribe aquí]",
      "¿Qué historia me cuento sobre la calma?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La calma no es vacío. A veces es seguridad."
    ],
      [
      "Cierre",
      "La calma no es vacío. A veces es seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Me quedo un minuto más en un lugar que no “emociona”.",
      "Me quedo un minuto más en un lugar que no “emociona”."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Límites que se rompen demasiado pronto",
    opening: localizedGenderNode(
      [
      "Hoy veo cuándo me abandono."
    ],
      [
      "Hoy veo cuándo me abandono."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿En qué momento empiezo a ceder un límite?\n[Escribe aquí]",
      "¿Qué temo que pase si lo mantengo?\n[Escribe aquí]",
      "¿Cómo me afecta después?\n[Escribe aquí]"
    ],
      [
      "¿En qué momento empiezo a ceder un límite?\n[Escribe aquí]",
      "¿Qué temo que pase si lo mantengo?\n[Escribe aquí]",
      "¿Cómo me afecta después?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una atracción que no respeta límites hiere."
    ],
      [
      "Cierre",
      "Una atracción que no respeta límites hiere."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un límite que fue importante para mí.",
      "Escribo un límite que fue importante para mí."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Patrón perseguidor–evasivo (si existe)",
    opening: localizedGenderNode(
      [
      "Hoy identifico un movimiento automático."
    ],
      [
      "Hoy identifico un movimiento automático."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Me atraen personas que se alejan?\n[Escribe aquí]",
      "¿Qué pasa dentro de mí cuando el otro no está disponible emocionalmente?\n[Escribe aquí]",
      "¿Qué rol tomo ahí?\n[Escribe aquí]"
    ],
      [
      "¿Me atraen personas que se alejan?\n[Escribe aquí]",
      "¿Qué pasa dentro de mí cuando el otro no está disponible emocionalmente?\n[Escribe aquí]",
      "¿Qué rol tomo ahí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un patrón es un movimiento, no mi identidad."
    ],
      [
      "Cierre",
      "Un patrón es un movimiento, no mi identidad."
    ]
    ),
    action: localizedGenderNode(
      "Cuando alguien se aleja — no persigo de inmediato. Respiro.",
      "Cuando alguien se aleja — no persigo de inmediato. Respiro."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Quién me vuelvo dentro de la relación",
    opening: localizedGenderNode(
      [
      "Hoy observo quién soy cuando estoy con ellos."
    ],
      [
      "Hoy observo quién soy cuando estoy con ellos."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me hablo a mí mismo/a en este tipo de relación?\n[Escribe aquí]",
      "¿Me siento más pequeño/a, tenso/a, confundido/a?\n[Escribe aquí]",
      "¿Quién quiero ser en una relación?\n[Escribe aquí]"
    ],
      [
      "¿Cómo me hablo a mí mismo/a en este tipo de relación?\n[Escribe aquí]",
      "¿Me siento más pequeño/a, tenso/a, confundido/a?\n[Escribe aquí]",
      "¿Quién quiero ser en una relación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una relación debería expandirme, no encogerme."
    ],
      [
      "Cierre",
      "Una relación debería expandirme, no encogerme."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una cualidad mía que desaparece en estas relaciones.",
      "Escribo una cualidad mía que desaparece en estas relaciones."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "El miedo al abandono que dirige la elección",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo sin dejar que decida por mí."
    ],
      [
      "Hoy toco el miedo sin dejar que decida por mí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi mayor miedo a estar solo/a?\n[Escribe aquí]",
      "¿Cómo influye en mis decisiones?\n[Escribe aquí]",
      "¿Qué verdad suave existe aunque el miedo esté ahí?\n[Escribe aquí]"
    ],
      [
      "¿Cuál es mi mayor miedo a estar solo/a?\n[Escribe aquí]",
      "¿Cómo influye en mis decisiones?\n[Escribe aquí]",
      "¿Qué verdad suave existe aunque el miedo esté ahí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo es una emoción, no una brújula."
    ],
      [
      "Cierre",
      "El miedo es una emoción, no una brújula."
    ]
    ),
    action: localizedGenderNode(
      "Digo: “Miedo, te veo. Elijo despacio.”",
      "Digo: “Miedo, te veo. Elijo despacio.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Lo que realmente necesito en una relación",
    opening: localizedGenderNode(
      [
      "Hoy defino necesidades, no fantasías."
    ],
      [
      "Hoy defino necesidades, no fantasías."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Tres necesidades básicas que tengo en una relación:\n[Escribe aquí]",
      "¿Existen en el patrón antiguo?\n[Escribe aquí]",
      "¿Qué es más importante para mí que la excitación?\n[Escribe aquí]"
    ],
      [
      "Tres necesidades básicas que tengo en una relación:\n[Escribe aquí]",
      "¿Existen en el patrón antiguo?\n[Escribe aquí]",
      "¿Qué es más importante para mí que la excitación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Las necesidades claras protegen el corazón."
    ],
      [
      "Cierre",
      "Las necesidades claras protegen el corazón."
    ]
    ),
    action: localizedGenderNode(
      "Guardo mi lista de necesidades en un lugar visible.",
      "Guardo mi lista de necesidades en un lugar visible."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "La atracción como dolor, no como destino",
    opening: localizedGenderNode(
      [
      "Hoy dejo de creer “así soy yo”."
    ],
      [
      "Hoy dejo de creer “así soy yo”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me he dicho sobre mi atracción a lo largo de los años?\n[Escribe aquí]",
      "¿Cómo se siente pensar que no es destino?\n[Escribe aquí]",
      "¿Qué se vuelve posible si aprendo a elegir distinto?\n[Escribe aquí]"
    ],
      [
      "¿Qué me he dicho sobre mi atracción a lo largo de los años?\n[Escribe aquí]",
      "¿Cómo se siente pensar que no es destino?\n[Escribe aquí]",
      "¿Qué se vuelve posible si aprendo a elegir distinto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No estoy roto/a — estoy aprendiendo."
    ],
      [
      "Cierre",
      "No estoy roto/a — estoy aprendiendo."
    ]
    ),
    action: localizedGenderNode(
      "Cambio una frase limitante por una más amable.",
      "Cambio una frase limitante por una más amable."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Pausar antes de la próxima elección",
    opening: localizedGenderNode(
      [
      "Hoy practico ir más despacio."
    ],
      [
      "Hoy practico ir más despacio."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo suelo apresurarme en las relaciones?\n[Escribe aquí]",
      "¿Qué pasa si espero un poco más?\n[Escribe aquí]",
      "¿Qué señal roja suelo ignorar?\n[Escribe aquí]"
    ],
      [
      "¿Cómo suelo apresurarme en las relaciones?\n[Escribe aquí]",
      "¿Qué pasa si espero un poco más?\n[Escribe aquí]",
      "¿Qué señal roja suelo ignorar?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una buena elección necesita tiempo."
    ],
      [
      "Cierre",
      "Una buena elección necesita tiempo."
    ]
    ),
    action: localizedGenderNode(
      "Hoy no me apresuro en ninguna decisión emocional.",
      "Hoy no me apresuro en ninguna decisión emocional."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Construir una nueva atracción",
    opening: localizedGenderNode(
      [
      "Hoy defino una atracción diferente."
    ],
      [
      "Hoy defino una atracción diferente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿A qué cualidades quiero aprender a sentir atracción?\n[Escribe aquí]",
      "¿Cómo se siente una relación que me respeta?\n[Escribe aquí]",
      "¿Qué valor me guiará de ahora en adelante?\n[Escribe aquí]"
    ],
      [
      "¿A qué cualidades quiero aprender a sentir atracción?\n[Escribe aquí]",
      "¿Cómo se siente una relación que me respeta?\n[Escribe aquí]",
      "¿Qué valor me guiará de ahora en adelante?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La atracción se puede reaprender."
    ],
      [
      "Cierre",
      "La atracción se puede reaprender."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un valor para acompañarme esta semana.",
      "Elijo un valor para acompañarme esta semana."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave y compromiso conmigo",
    opening: localizedGenderNode(
      [
      "Hoy resumo sin juzgar."
    ],
      [
      "Hoy resumo sin juzgar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué comprendí sobre mí en este camino?\n[Escribe aquí]",
      "¿Qué dejo de hacer en las relaciones?\n[Escribe aquí]",
      "Frase de regreso para días de confusión:\n[Escribe aquí]"
    ],
      [
      "¿Qué comprendí sobre mí en este camino?\n[Escribe aquí]",
      "¿Qué dejo de hacer en las relaciones?\n[Escribe aquí]",
      "Frase de regreso para días de confusión:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "No me atrae lo que me daña —",
      "estoy aprendiendo a escuchar lo que me respeta.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ],
      [
      "Cierre final del recorrido",
      "No me atrae lo que me daña —",
      "estoy aprendiendo a escuchar lo que me respeta.",
      "Sigo caminando —",
      "despacio, en silencio, conmigo.",
      "Y eso es fuerza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que simbolice una nueva elección (escritura / conversación segura / orden interno).",
      "Una acción que simbolice una nueva elección (escritura / conversación segura / orden interno)."
    ),
  },
].map(buildNormalizedDay);

export const repeatedAttractionToDestructivePartnersBlueprintEs = buildNormalizedPilotBlueprint({
  id: "repeated_attraction_to_destructive_partners_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "repeated_attraction_to_destructive_partners",
  category: "general",
  journeyName: {
    he: "משיכה חוזרת לבני/בנות זוג הרסניים",
    en: "Repeated Attraction to Destructive Partners",
    es: "Atracción Repetida por Parejas Destructivas",
  },
  days,
});

export default repeatedAttractionToDestructivePartnersBlueprintEs;
